import { get } from 'lodash'
import { SUBCATEGORIES } from 'constants/layout/setup-activity'

export default function(props) {
  const customCategory = get(props, 'activityCategory.userDefined')

  const transportationModes = get(props, 'transportationModes')

  const transportationModeList = transportationModes && transportationModes.map(item => {
    return {
      id: get(item, 'transportationMode.id'),
      value: get(item, 'transportationMode.modeOfTransportType.value'),
      label: get(item, 'transportationMode.modeOfTransportType.translationText')
    }
  })

  return {
    ...props,
    activityCategory: {
      id: customCategory
        ? SUBCATEGORIES.others.value
        : get(props, 'activityCategory.id')
    },
    helpers: {
      category: get(props, 'activityCategory.parent.id'),
      location: get(props, 'location'),
      others: customCategory
        ? get(props, 'activityCategory.translatedName')
        : undefined
    },
    transportationModes: transportationModeList
  }
}
